import styled, { css } from 'styled-components';

export const ImageAttachment = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
`;

export const ViewerRoot = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const ViewerToolbar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding-bottom: 8px;
`;

export const ViewerPageContainer = styled.div`
  flex: 1;
  overflow: auto;
  touch-action: none;
`;

export const ViewerPageSizer = styled.div.withConfig({
  shouldForwardProp: prop => prop !== 'pinchWidth' && prop !== 'pinchHeight',
})`
  ${({ pinchWidth, pinchHeight } = {}) =>
    pinchWidth != null && pinchHeight != null
      ? css`
          width: ${pinchWidth}px;
          height: ${pinchHeight}px;
        `
      : ''}
`;

export const ViewerPageWrapper = styled.div.withConfig({
  shouldForwardProp: prop => prop !== 'pinchScale',
})`
  transform-origin: 0 0;
  ${({ pinchScale } = {}) =>
    pinchScale != null
      ? css`
          transform: scale(${pinchScale});
        `
      : ''}
`;

export default css`
  padding: 0;
  height: 100px;
  overflow: auto;
  flex-grow: 1;

  div.attachment {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    padding: 4px 0;

    &.is-loading {
      opacity: 0.5;
      pointer-events: none;
    }
  }
`;
